'use strict';

class ImageLightbox {
  static MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  static init() {
    if (ImageLightbox.instance) return ImageLightbox.instance;

    const root = document.createElement('div');
    root.className = 'image-lightbox';
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = `
      <button type="button" class="image-lightbox__overlay" data-lightbox-close aria-label="閉じる"></button>
      <div class="image-lightbox__panel">
        <button type="button" class="image-lightbox__close" data-lightbox-close aria-label="閉じる">
          <span aria-hidden="true">&times;</span>
        </button>
        <img class="image-lightbox__image" alt="">
      </div>
    `;

    document.body.appendChild(root);

    ImageLightbox.instance = new ImageLightbox(root);
    return ImageLightbox.instance;
  }

  constructor(root) {
    this.root = root;
    this.panel = root.querySelector('.image-lightbox__panel');
    this.image = root.querySelector('.image-lightbox__image');
    this.lastTrigger = null;

    root.querySelectorAll('[data-lightbox-close]').forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        ImageLightbox.close();
      });
    });
  }

  static isOpen() {
    return Boolean(ImageLightbox.instance?.root && !ImageLightbox.instance.root.hidden);
  }

  static getTriggerSrc(trigger, key) {
    return trigger.getAttribute(key) || '';
  }

  static resolveSrc(trigger) {
    const pcSrc = ImageLightbox.getTriggerSrc(trigger, 'data-lightbox-src-pc');
    const spSrc = ImageLightbox.getTriggerSrc(trigger, 'data-lightbox-src-sp');
    const isMobile = ImageLightbox.MOBILE_MQ.matches;

    if (isMobile) {
      return spSrc || pcSrc;
    }

    return pcSrc || spSrc;
  }

  static openFromTrigger(trigger) {
    const src = ImageLightbox.resolveSrc(trigger);
    if (!src) return;

    ImageLightbox.open({
      src,
      alt: ImageLightbox.getTriggerSrc(trigger, 'data-lightbox-alt'),
      trigger,
    });
  }

  static open({ src, alt = '', trigger = null }) {
    const instance = ImageLightbox.init();
    instance.lastTrigger = trigger;
    instance.image.setAttribute('src', src);
    instance.image.alt = alt;
    instance.root.hidden = false;
    instance.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('image-lightbox-open');
    instance.root.querySelector('.image-lightbox__close')?.focus();
  }

  static close() {
    const instance = ImageLightbox.instance;
    if (!instance || instance.root.hidden) return;

    instance.root.hidden = true;
    instance.root.setAttribute('aria-hidden', 'true');
    instance.image.removeAttribute('src');
    instance.image.alt = '';
    document.body.classList.remove('image-lightbox-open');

    if (instance.lastTrigger) {
      instance.lastTrigger.focus();
      instance.lastTrigger = null;
    }
  }

  static bindTriggers(root = document) {
    ImageLightbox.init();

    root.querySelectorAll('.image-lightbox-trigger:not([data-lightbox-bound])').forEach((trigger) => {
      if (trigger.closest('usage-slider')) return;

      trigger.dataset.lightboxBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        ImageLightbox.openFromTrigger(trigger);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ImageLightbox.bindTriggers();
});

document.addEventListener('shopify:section:load', (event) => {
  ImageLightbox.bindTriggers(event.target);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && ImageLightbox.isOpen()) {
    ImageLightbox.close();
  }
});
